import { DBInstance } from '@repo/db'
import { ComponentInfoChatVO, NotificationType } from '@repo/types'

export const handlePayloadByType = async (
  type: NotificationType,
  payload: ComponentInfoChatVO,
  dbInstance?: DBInstance
) => {
  switch (type) {
    case NotificationType.NEW_CHAT:
      console.debug('Novo chat recebido')
      await dbInstance?.chatRepository.addChat(payload)
      break
    case NotificationType.ARCHIVED_CHAT:
      console.debug('Chat arquivado')
      await dbInstance?.chatRepository.archiveChat(payload)
      break
    case NotificationType.UPDATE_CHAT:
      console.debug('Chat atualizado')
      await dbInstance?.chatRepository.addChat(payload)
      break
    case NotificationType.NEW_MESSAGE:
      console.debug('Nova mensagem recebida')
      await dbInstance?.chatRepository.addChat(payload)
      break
    case NotificationType.USER_AVAILABLE:
      console.debug('Diponibilidade do usuário recebida')
      break
    default:
      console.debug('Tipo recebido não encontrado')
      break
  }
}
